import React from "react";
import { C, FONT } from "../../constants/mq";

// Macquarie look (src/constants/mq.js), scoped to this section so the legacy
// courses-details.css still loads but no longer decides the look: underlined
// tabs, charcoal headings, and the text-type lists as hairline rows with a
// small red marker. The cartoon book and rocket illustrations are gone.
const css = `
.cd-mq { font-family: ${FONT}; }
.cd-mq .container { max-width: none; padding: 0; }
.cd-mq .tab-panel-sec { padding: 56px 0 0; }
.cd-mq .tab-box { border-bottom: 1px solid ${C.line}; }
.cd-mq .tab-course { display: flex; flex-wrap: wrap; gap: 0 28px; border-bottom: 1px solid ${C.line}; }
.cd-mq .tab-course button {
  background: none; border: none; border-bottom: 3px solid transparent; border-radius: 0;
  margin-bottom: -1px; padding: 10px 2px 12px;
  font-family: inherit; font-size: 15px; font-weight: 600; line-height: 1.4; color: ${C.muted};
}
.cd-mq .tab-course button:hover { background: none; color: ${C.ink}; }
.cd-mq .tab-course button.active { background: none; color: ${C.ink} !important; border-bottom-color: ${C.bright}; }
.cd-mq .tablinks.active:before { display: none; }
.cd-mq .tabcon { padding: 26px 0 14px; }
.cd-mq .title-hd {
  font-family: inherit; font-size: 17px; font-weight: 700; line-height: 1.4;
  color: ${C.ink}; margin: 24px 0 8px;
}
.cd-mq .tabcon .title-hd:first-child { margin-top: 0; }
.cd-mq .text-para p { font-family: inherit; font-size: 15px; line-height: 1.75; color: ${C.body}; margin: 0 0 16px; }
.cd-mq .lists-courses-sec { padding: 32px 0 72px; }
.cd-mq .course-detail { display: grid; grid-template-columns: 1fr 1fr; gap: 0 32px; padding: 4px 0 32px; }
.cd-mq .strategy-list.list-course { width: auto; }
.cd-mq .strategy-list ul li {
  display: flex; align-items: baseline; gap: 12px; padding: 11px 0;
  border-bottom: 1px solid ${C.line};
  font-family: inherit; font-size: 14.5px; font-weight: 600; line-height: 1.5; color: ${C.ink};
}
.cd-mq .strategy-list ul li:before {
  content: ""; flex-shrink: 0; width: 6px; height: 6px; margin: 0; padding: 0;
  border: 0; border-radius: 0; background: ${C.bright}; transform: translateY(-2px);
}
@media (max-width: 991px) {
  .cd-mq .course-detail { grid-template-columns: 1fr; }
}
@media (max-width: 767px) {
  .cd-mq .tab-panel-sec { padding-top: 40px; }
}
`;

function CourseDetailSection() {
  return (
    <div class="middle-box cd-mq">
      <style>{css}</style>
      <section class="tab-panel-sec">
        <div class="tab-inner container">
          <div class="tab-box">
            <div class="tab-course">
              <button
                class="tablinks active"
                onclick="openCourse(event, 'Literacy')"
              >
                Literacy
              </button>
              <button
                class="tablinks"
                onclick="openCourse(event, 'Language Convention')"
              >
                Language Convention
              </button>
              <button
                class="tablinks"
                onclick="openCourse(event, 'Literature')"
              >
                Literature
              </button>
            </div>

            <div id="Literacy" class="tabcon" style={{ display: "block" }}>
              <div class="title-hd" data-aos="fade-left">
                Reading Comprehension
              </div>
              <div class="text-para">
                <p>
                  Each unit commences with a Reading Strategy to provide
                  students the skills to read and comprehend successfully.
                  Subsequent exercises comprise Reading Comprehension tasks in
                  which students demonstrate their ability to interpret, analyse
                  & evaluate texts with appropriateness, accuracy, confidence
                  and fluency. Varied multi-modal reading texts are sourced from
                  different cultures, historical periods & genres. Students
                  learn to comprehend what they read and view by applying
                  reading strategies, contextual, semantic & grammatical
                  knowledge. With these reading & language skills, they develop
                  more sophisticated processes for interpreting, analysing,
                  evaluating and critiquing ideas, information and issues from a
                  variety of sources. In the course of the term, various reading
                  strategies will be taught.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-right">
                Listening & Speaking
              </div>
              <div class="text-para">
                <p>
                  Students are exposed to these skills in the English lessons.
                  However, these skills are taught specifically during the
                  Holiday Courses, for example in Public Speaking, Poetry
                  Recitation & Oral Presentation.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-left">
                Viewing
              </div>
              <div class="text-para">
                <p>
                  Today? literacy skills include interpreting and understanding
                  visual texts. To this end, some of our reading & writing tasks
                  include visuals such as cartoons, graphs, charts & pictures.
                  Students are trained to interpret these texts appropriately.
                </p>
              </div>
            </div>

            <div id="Language Convention" class="tabcon">
              <div class="title-hd" data-aos="fade-right">
                Viewing
              </div>
              <div class="text-para">
                <p>
                  Today? literacy skills include interpreting and understanding
                  visual texts. To this end, some of our reading & writing tasks
                  include visuals such as cartoons, graphs, charts & pictures.
                  Students are trained to interpret these texts appropriately.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-left">
                Reading Comprehension
              </div>
              <div class="text-para">
                <p>
                  Each unit commences with a Reading Strategy to provide
                  students the skills to read and comprehend successfully.
                  Subsequent exercises comprise Reading Comprehension tasks in
                  which students demonstrate their ability to interpret, analyse
                  & evaluate texts with appropriateness, accuracy, confidence
                  and fluency. Varied multi-modal reading texts are sourced from
                  different cultures, historical periods & genres. Students
                  learn to comprehend what they read and view by applying
                  reading strategies, contextual, semantic & grammatical
                  knowledge. With these reading & language skills, they develop
                  more sophisticated processes for interpreting, analysing,
                  evaluating and critiquing ideas, information and issues from a
                  variety of sources. In the course of the term, various reading
                  strategies will be taught.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-right">
                Listening & Speaking
              </div>
              <div class="text-para">
                <p>
                  Students are exposed to these skills in the English lessons.
                  However, these skills are taught specifically during the
                  Holiday Courses, for example in Public Speaking, Poetry
                  Recitation & Oral Presentation.
                </p>
              </div>
            </div>

            <div id="Literature" class="tabcon">
              <div class="title-hd" data-aos="fade-left">
                Viewing
              </div>
              <div class="text-para">
                <p>
                  Today? literacy skills include interpreting and understanding
                  visual texts. To this end, some of our reading & writing tasks
                  include visuals such as cartoons, graphs, charts & pictures.
                  Students are trained to interpret these texts appropriately.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-right">
                Listening & Speaking
              </div>
              <div class="text-para">
                <p>
                  Students are exposed to these skills in the English lessons.
                  However, these skills are taught specifically during the
                  Holiday Courses, for example in Public Speaking, Poetry
                  Recitation & Oral Presentation.
                </p>
              </div>

              <div class="title-hd" data-aos="fade-left">
                Reading Comprehension
              </div>
              <div class="text-para">
                <p>
                  Each unit commences with a Reading Strategy to provide
                  students the skills to read and comprehend successfully.
                  Subsequent exercises comprise Reading Comprehension tasks in
                  which students demonstrate their ability to interpret, analyse
                  & evaluate texts with appropriateness, accuracy, confidence
                  and fluency. Varied multi-modal reading texts are sourced from
                  different cultures, historical periods & genres. Students
                  learn to comprehend what they read and view by applying
                  reading strategies, contextual, semantic & grammatical
                  knowledge. With these reading & language skills, they develop
                  more sophisticated processes for interpreting, analysing,
                  evaluating and critiquing ideas, information and issues from a
                  variety of sources. In the course of the term, various reading
                  strategies will be taught.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="lists-courses-sec">
        <div class="list-courses-inner container">
          <div class="text-para">
            <p>
              In English, students reading skills are tested and developed
              through the study of ten different text types. Students will learn
              to apply their current knowledge to understand how different text
              types are suited to conveying different types of information. The
              text types that students should become familiar with are:
            </p>
          </div>
          <div class="course-detail">
            <div class="strategy-list list-course">
              <ul>
                <li>Narratives</li>
                <li>Procedures </li>
                <li>Information Reports</li>
                <li>Graphs</li>
                <li>Poems</li>
              </ul>
            </div>

            <div class="strategy-list list-course">
              <ul>
                <li>Scripts</li>
                <li>Cartoons </li>
                <li>Advertisements/Brochures</li>
                <li>Persuasive</li>
                <li>Opinion Pieces</li>
              </ul>
            </div>
          </div>

          <div class="text-para">
            <p>
              After studying these text types, students will learn to answer two
              types of questions; literal and inference style questions. These
              question types are further divided into twelve categories that
              develop students reading skills. These skills are as follows:
            </p>
          </div>

          <div class="course-detail">
            <div class="strategy-list list-course">
              <ul>
                <li>Identifying Author’s Purpose</li>
                <li>Drawing Conclusions and Making Inferences </li>
                <li>Identifying the Main Idea</li>
                <li>Finding Word Meaning in Context</li>
                <li>Identifying Cause and Effect</li>
                <li>Interpreting Figurative Language</li>
              </ul>
            </div>
            <div class="strategy-list list-course">
              <ul>
                <li>Comparing and Contrasting </li>
                <li>Concluding Context</li>
                <li>Understanding Sequence of Events</li>
                <li>Interpreting Information</li>
                <li>Distinguishing between Facts and Opinion</li>
                <li>Predicting future events</li>
              </ul>
            </div>
          </div>

          <div class="text-para">
            <p>
              Some of these reading skills are clearly suited to literal
              questions. These include but are not limited to questions
              involving interpreting, comparing and contrasting information.
              Other skills are more ambiguous and may apply to both literal and
              inference-style questions. Identifying the author’s purpose can be
              very straight-forward in information reports-thus a question about
              this would be considered a literal question. However, making
              inferences requires students to pick up subtle clues and given
              information to draw their own conclusion and develop their own
              predictions-thus, such questions would be considered
              inference-style questions.
            </p>
          </div>

          <div class="text-para">
            <p>
              The development of reading skills through the study of English
              improves students’ ability to understand, critically analyse and
              evaluate the reliability of various texts, making it a very
              valuable life skill.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CourseDetailSection;
